import i18n, { Module } from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

import { I18N_DEFAULT_NAMESPACE, I18N_FALLBACK_LANGUAGE, I18N_NAMESPACES, isOtaEnabled } from './config';
import { CrowdinOtaBackend } from './crowdin-ota-backend';

const backend: Module = isOtaEnabled() ? CrowdinOtaBackend : HttpBackend;

i18n
  .use(backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: I18N_FALLBACK_LANGUAGE,
    ns: [...I18N_NAMESPACES],
    defaultNS: I18N_DEFAULT_NAMESPACE,
    detection: {
      order: ['querystring', 'navigator', 'sessionStorage'],
      lookupQuerystring: 'lang',
      caches: [],
    },
    backend: isOtaEnabled()
      ? undefined
      : {
          loadPath: '/locales/{{lng}}/{{ns}}.json',
        },
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: true,
    },
  });

export default i18n;
